import { useState, useEffect } from "react";
import DoctorCard from "../cards/DoctorCard";
import DoctorsData from "../doctorsData/DoctorsData";
import AppointmentModal from "../modal/AppointmentModal";

export default function HomeContent() {
    const [isVisible, setIsVisible] = useState(false);
    const [docData, setDocData] = useState(null);

    useEffect(() => {
        // Create the noscript element
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WHWCQ2C7" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

        // Append the noscript to the body
        document.body.appendChild(noscript);

        // Cleanup on unmount
        return () => {
            document.body.removeChild(noscript);
        };
    }, []); // Empty dependency array ensures this runs only once

    return (
        <>
            <div className="home-container" id="Therapists">
                <div className="content">
                    <h1 data-aos={'fade-down'}>Get to know the YJC and Wellness team</h1>
                    <p data-aos={'fade-up'}>
                        We have an incredible group of therapists who are encouraged to be unique and creative while
                        offering customized care. To learn more about the team, check out their bios below!
                    </p>
                    {/* Doctor Cards */}
                    {isVisible && (
                        <AppointmentModal
                            isVisible={isVisible}
                            setIsVisible={setIsVisible}
                            doctor={docData}
                        />
                    )}
                    <div className="doctor-cards-list">
                        {DoctorsData.map((doctor) => (
                            <DoctorCard
                                key={doctor.id}
                                doctor={doctor}
                                setIsVisible={setIsVisible}
                                isVisible={isVisible}
                                setDocData={setDocData}
                            />
                        ))}
                    </div>
                </div>
                <div className="section">
                    <h1>We know! It’s hard to pick.</h1>
                    <p>All of our therapists are a great choice – but you can’t pick them all. Let us help!</p>
                    <a
                        href="https://yjcandwellness.com/#contact-us"
                        target="_blank"
                        className="btn-appointment"
                    >
                        Contact Us
                    </a>
                </div>
            </div>
        </>
    );
}
